import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-mensagem-alerta',
  templateUrl: './mensagem-alerta.component.html',
  styleUrls: ['./mensagem-alerta.component.scss']
})
export class MensagemAlertaComponent {
  @Input() titulo: string;
  @Input() mensagem: string;
  @Input() textoBotao: string = 'ACESSAR NOVO PORTAL';
  @Input() linkBotao: string = '';
  @Input() targetBotao: string = '_blank';
}
